import { useQuery } from "@tanstack/react-query";
import { getTravelTypes } from "../api/planner";
import { useTranslation } from "react-i18next";

export const useTravelTypes = () => {
    const { i18n } = useTranslation();
    return useQuery({
        queryKey: ["travel-types", i18n.resolvedLanguage],
        queryFn: () => getTravelTypes(i18n.resolvedLanguage || "en"),
        staleTime: Infinity,
    });
};
